<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h">BOOK ONE</p>
<p class="part-center">The Morning Opes Her Golden Gates</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6e6cda65